
import { Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { ClassMetadata, IRepositoryRecalc, MetadataCollectionVerification, MetadataVerification, RecalculateReturn, RepositoryBulkDeleteArg, RepositoryBulkDeleteResult, RepositoryDataCollection, RepositoryDataCollectionRecalc, RepositoryGet, Tuple } from "@tylertech/tyler-api-types";

/**
 * RepositoryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RepositoryService {
    constructor(private readonly $apiService: ApiService) { }
    
    BulkDelete(arg: RepositoryBulkDeleteArg): Promise<RepositoryBulkDeleteResult> {
        return this.$apiService.sendAuth("IRepositoryService/BulkDelete", arg);
    }
    BulkDeleteById(arg: RepositoryBulkDeleteArg): Promise<RepositoryBulkDeleteResult> {
        return this.$apiService.sendAuth("IRepositoryService/BulkDeleteById", arg);
    }
    Copy(collection: RepositoryDataCollection): Promise<any> {
        return this.$apiService.sendAuth("IRepositoryService/Copy", collection);
    }
    Fetch(type: string, filterString?: string): Promise<any[]> {
        return this.$apiService.sendAuth("IRepositoryService/Fetch", type, filterString);
    }
    FetchWithQuestions(typeAndQuestions: Tuple<string, { [key: string]: boolean }>, filterString?: string): Promise<any[]> {
        return this.$apiService.sendAuth("IRepositoryService/FetchWithQuestions", typeAndQuestions, filterString);
    }
    Get(typeAndId: Tuple<string, string>, filterString?: string): Promise<any> {
        return this.$apiService.sendAuth("IRepositoryService/Get", typeAndId, filterString);
    }
    GetMetadata(typeAndString: Tuple<string, string>): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IRepositoryService/GetMetadata", typeAndString);
    }
    GetNew(typeAndString: Tuple<string, string>, filterString?: string): Promise<any> {
        return this.$apiService.sendAuth("IRepositoryService/GetNew", typeAndString, filterString);
    }
    GetWithQuestions(get: RepositoryGet, filterString?: string): Promise<any> {
        return this.$apiService.sendAuth("IRepositoryService/GetWithQuestions", get, filterString);
    }
    ODataMetadataXml(type: string): Promise<string> {
        return this.$apiService.sendAuth("IRepositoryService/ODataMetadataXml", type);
    }
    RecalculateDataCollection(recalc: RepositoryDataCollectionRecalc): Promise<RepositoryDataCollection> {
        return this.$apiService.sendAuth("IRepositoryService/RecalculateDataCollection", recalc);
    }
    RecalculateGridView(collectionAndGridId: Tuple<RepositoryDataCollection, string>): Promise<RepositoryDataCollection> {
        return this.$apiService.sendAuth("IRepositoryService/RecalculateGridView", collectionAndGridId);
    }
    RecalculateProperties(recalc: IRepositoryRecalc): Promise<RecalculateReturn> {
        return this.$apiService.sendAuth("IRepositoryService/RecalculateProperties", recalc);
    }
    Save(typeAndJsonString: Tuple<string, string>): Promise<any> {
        return this.$apiService.sendAuth("IRepositoryService/Save", typeAndJsonString);
    }
    SaveAll(collection: RepositoryDataCollection): Promise<RepositoryDataCollection> {
        return this.$apiService.sendAuth("IRepositoryService/SaveAll", collection);
    }
    Verify(typeAndJsonString: Tuple<string, string>): Promise<MetadataVerification> {
        return this.$apiService.sendAuth("IRepositoryService/Verify", typeAndJsonString);
    }
    VerifyAll(collection: RepositoryDataCollection): Promise<MetadataCollectionVerification> {
        return this.$apiService.sendAuth("IRepositoryService/VerifyAll", collection);
    }
}
